import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  info: null,  // Aquí se almacenará la info de la card seleccionada
  isOpen: false,  // Si está abierto o no el modal
};

const modalSlice = createSlice({
  name: 'modal',
  initialState,
  reducers: {
    openModal: (state, action) => {
      state.info = action.payload;  // Asigna la info de la card al store
      state.isOpen = true;  // Abre el modal
    },
    closeModal: (state) => {
      state.info = null;  // Limpia la info cuando se cierra el modal
      state.isOpen = false;  // Cierra el modal
    },
  },
});

export const { openModal, closeModal } = modalSlice.actions;

export default modalSlice.reducer;
